__turbopack_context__.v({
  "item": "ScrollspyNav-module__x947NG__item",
  "list": "ScrollspyNav-module__x947NG__list",
  "nav": "ScrollspyNav-module__x947NG__nav",
  "tab": "ScrollspyNav-module__x947NG__tab",
});
